export const HOME_PATH = "/";
export const LATEST_PATH = "/latest";
export const CART_PATH = "/cart";
export const SEARCH_PATH = "/search";

export const itemPath = (id) => `/item/${id}`;

// Overlay routes render on top of the last browsing page instead of replacing it.
export const isOverlayPath = (pathname) => /^\/(item\/[^/]+|search)\/?$/.test(pathname);

export function shopPath({ department = "All", subcategory = "All", size = "All", sort = "new" } = {}) {
  let path = HOME_PATH;
  if (department !== "All") {
    path = `/shop/${encodeURIComponent(department)}`;
    if (subcategory !== "All") path += `/${encodeURIComponent(subcategory)}`;
  }
  const query = new URLSearchParams();
  if (size !== "All") query.set("size", size);
  if (sort !== "new") query.set("sort", sort);
  const search = query.toString();
  return search ? `${path}?${search}` : path;
}
